<div id="AIContent" class="detailpage__content" [ngClass]="[isPantherLakeStdxe ? 'ptl-12xe-ai-wrapper':'']">
  <div class="AI-body">
    <div class="AI-title" [class.AI-title_ar]="language ==='ar-sa'" [class.intelOne-display]="language ==='en-us'" [class.ptl-12xe-ai-title]="isPantherLakeStdxe" [innerHTML]="aiDemoTitleArray[0]?.tr_title">
    </div>
    <div class="AI_subTitle" [class.ptl-12xe-ai-subtitle]="isPantherLakeStdxe" [innerHTML]="aiDemoTitleArray[0]?.tr_subtitle" [class.intelOne-display]="language ==='en-us'"></div>
    <div class="tabs" *ngIf="availableFilters.length > 0" [class.intelOne-display]="language ==='en-us'">
      <div *ngFor="let filterType of availableFilters" class="tabs-btn" [class.ptl-std-tabs-btn]="isPantherLakeStd" [class.ptl-12xe-tabs-btn]="isPantherLakeStdxe" [class.activeStd]="selectedFilters.includes(filterType.key) && isPantherLakeStd" [class.active12xe]="selectedFilters.includes(filterType.key) && isPantherLakeStdxe" 
     [class.wcl-tabs-btn]="isWildCatLakeStd"  [class.activeWclStd]="selectedFilters.includes(filterType.key) && isWildCatLakeStd" (click)="toggleFilter(filterType.key)">
        <div id="" class="tab-heading" [ngClass]="{'tab-heading_nonEng': language !== 'en-us'}" [innerHTML]="filterType.value">
        </div>
        <img *ngIf="selectedFilters.includes(filterType.key)" [src]="filterCloseIcon" alt="remove filter" />
      </div>
    </div>
    <div class="tabs-content" [ngClass]="[(isPantherLakeStd || isPantherLakeStdxe || isWildCatLakeStd) && filteredPanelData.length > 1 ? 'ptl-tab-content-gap' : '']" [class.show-ai-demo-scrollbar]="filteredPanelData.length > 4">
      <div class="AI_cards_main" [ngClass]="[(isPantherLakeStd || isPantherLakeStdxe || isWildCatLakeStd) ? 'ptl-ai-card-main' : '', filteredPanelData.length > 1 ? 'tabs-content-bottom-space':'']" *ngFor="let demo of filteredPanelData">
        <div class="AI_card" [ngClass]="[isPantherLakeStd ? 'ptl-std-ai-card':'']" (click)="routeToDetails(demo?.tileVideoUrl)">
          <div class="AI_card_media">
            <img [src]="demo.imgUrl" class="card-img-top" alt="card background" />
            <div class="filter-label" [innerHTML]="demo?.categoryLabel" [class.intelOne-display]="language ==='en-us'" [ngClass]="isPantherLakeStd ? 'ptl-filter-label' : isPantherLakeStdxe ? 'ptl-12xe-filter-label':'isWildCatLakeStd'?'wcl-filter-label' : selectedFilters.length > 0 ? 'filter-label-selected' : 'filter-label-deselected'" [class.ptl-12xe-filter-label]="isPantherLakeStdxe">
            </div>
          </div>
          <div class="AI-body-main">
            <div class="media-title" [class.intelOne-display]="language ==='en-us'" [ngClass]="[isPantherLakeStdxe ? 'ptl-12xe-media-title':isWildCatLakeStd?'wcl-media-title':'']" [innerHTML]="demo?.tr_title"></div>
            <div class="AI_card_body" [ngClass]="language != 'en-us' ? 'AI_card_body-lang':''">
              <div class="media-subtitle">
                <span class="ai-card-content">
                  <img class="ai-card-content-logo" [src]="demo.tileBadgeUrl" alt="logo" />
                  <img class="ai-card-content-arrow" [src]="demo.arrowUrl" alt="explore" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isPantherLakeStd || isPantherLakeStdxe || isWildCatLakeStd" class="ptl-bottom">
      <div [class.intelOne-display]="language ==='en-us'" class="ptl-bottom-text" [innerHTML]="aiDemoTitleArray[0]?.tr_notes"> </div>
    </div>
  </div>
  <ng-template #AIModal let-modal>
    <div id="modalBody" class="modal-body">
      <div class="AI_modal_card">
        <video (play)="playPauseAIVideo(EVideoAction.play)" (ended)="playPauseAIVideo(EVideoAction.complete)" (pause)="playPauseAIVideo(EVideoAction.pause)" id="aiVideo" #videoAiPlayer [muted]="true" disablePictureInPicture autoplay controls controlsList="noplaybackrate nodownload">
          <source [src]="videoLink" type="video/mp4" />
          <track label="English" kind="subtitles" srclang="en" src="subtitleSonar" default>
        </video>
        <div id="AINavigation" class="AI-close" (click)="dismissAIVideoPanel()">
          <img [src]="closeIcon" alt="go to home page" />
        </div>
      </div>
    </div>
  </ng-template>
</div>